//  解密
import { hybrid } from '@kd/hybrid';
export const doCr4Decode = (arr: string[]): Promise<any> => {
  const isDev = process.env.NODE_ENV === 'development'
  if(isDev) {
      const obj:{[key:string]: string} = {}
      arr.forEach(item => obj[item] = item)
      return Promise.resolve(obj)
  }
  return new Promise((resolve, reject) => {
    hybrid(
      'getRc4DecryptData',
      {
        encryptData: JSON.stringify(arr)
      },
      (data: { decryptData: string }) => {
        if (data.decryptData) {
          resolve(JSON.parse(data.decryptData));
        } else {
          reject(data);
        }
      }
    );
  });
};
interface resItem {
  isLogin: boolean;
}
interface resultItem {
  result: boolean;
}
// app登陆
export const appLogin = (): Promise<unknown> => {
  return new Promise((resolve: any) => {
    hybrid('is_login', (res: resItem) => {
      if (res?.isLogin) {
        resolve();
      } else {
        hybrid('loginForResult', (result: resultItem) => {
          if (result?.result) {
            resolve();
          }
        });
      }
    });
  });
};
